module.exports = __webpack_public_path__ + "img/img.ccc5631d.svg";